import { getInjector, getRootScope } from '@/services/angularjs-bridge';
import { restUrl } from '@/services/utils';

declare const angular: {
    copy: <T>(value: T) => T;
    extend: (destination: object, source: object) => object;
};

interface UserRecord {
    userId?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    imageUrl?: string;
    systemAccount?: boolean;
    managingAccount?: boolean;
    customValues?: Record<string, unknown>;
    [key: string]: unknown;
}

interface UserResourceApi {
    get: (
        params: Record<string, never>,
        onSuccess: (response: UserRecord) => void,
        onError?: (response: { status?: number }) => void,
    ) => void;
    save: (
        data: UserRecord,
        onSuccess: (response: UserRecord) => void,
        onError: (response: { status?: number }) => void,
    ) => void;
    changePassword: (
        data: { oldPassword: string; newPassword: string },
        onSuccess: () => void,
        onError: (response: { status?: number }) => void,
    ) => void;
}

interface SingleSignOnResourceApi {
    get: (
        params: Record<string, never>,
        onSuccess: (response: { protocol?: string }) => void,
        onError?: (response: { status?: number }) => void,
    ) => void;
}

interface RootScopeApi {
    user?: UserRecord;
    prepareAttributes: (attributes: unknown[]) => void;
    dataModel: {
        getUserAttributes: () => unknown[];
    };
    $broadcast: (name: string, payload?: unknown) => void;
    loadContacts?: () => void;
}

function cloneUser(user: UserRecord): UserRecord {
    return angular.copy(user);
}

function mergeUser(rootScope: RootScopeApi, response: UserRecord): UserRecord {
    const current = rootScope.user || {};
    rootScope.user = current;
    angular.extend(current, response);
    return current;
}

function userBridge() {
    const injector = getInjector();
    return {
        rootScope: getRootScope(injector) as RootScopeApi,
        userResource: injector.get('UserResource') as UserResourceApi,
        singleSignOnResource: injector.get('SingleSignOnResource') as SingleSignOnResourceApi,
    };
}

function userImageUrl() {
    return restUrl('user/image');
}

export {
    cloneUser,
    mergeUser,
    userBridge,
    userImageUrl,
};
export type { UserRecord };
